import { render } from "./TileSelection.vue?vue&type=template&id=a0a521d0"
import script from "./TileSelection.vue?vue&type=script&lang=js"
export * from "./TileSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__